import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/translations";

const LangContext = createContext({ lang: "de", setLang: () => {}, t: (k) => k });

const STORAGE_KEY = "x10_lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "de";
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "de" || stored === "en") return stored;
    const browser = (navigator.language || "de").toLowerCase().startsWith("de") ? "de" : "en";
    return browser;
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const setLang = (l) => setLangState(l === "en" ? "en" : "de");

  const dict = translations[lang] || translations.de;

  /** Lookup function: t("nav.services") */
  const t = (path) => {
    if (!path) return "";
    return path.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : null), dict) ?? path;
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t, dict }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
